import * as TokenActions from './actions';

const initialState = {
  tokenId: "",
  sent: false,
  jabraNumber: null,
  startTime: null,
  endTime: null,
  multipleCanceling: false,
  confirmedQueueFromSearchPage: []
};

const tokenReducer = (state = initialState, action) => {
  switch (action.type) {
    case TokenActions.TOKENID_FETCHING: {
      return {
        ...state,
        tokenId: action.tokenId,
        sent: true
      }
    }
    case TokenActions.TOKENID_FETCHED: {
      return {
        ...state,
        tokenId: action.tokenId,
        sent: false,
        multipleCanceling: false
      }
    }
    case TokenActions.TOKEN_SENT: {
      return {
        ...state,
        tokenId: action.tokenId,
        sent: true
      }
    }
    case TokenActions.TOKEN_MULTIPLE_CANCEL: {
      return {
        ...state,
        multipleCanceling: true
      }
    }
    case TokenActions.RESERVE_CONFIRMED_AT_SEARCHPAGE: {
      return {
        ...state,
        confirmedQueueFromSearchPage: action.confirmedQueueFromSearchPage
      }
    }
    default: {
      return state;
    }
  }
}

export default tokenReducer;
